<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Students Club'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="10"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Students Club</div>
          <tab-view>
            <tab-panel>
              <template #header>
                <i class="pi pi-home mr-1"></i>
                <span>About</span>
              </template>
              <p class="text-justify text-gray-600">Civil Engineering Student Association is an organization formed by
                the students which works for the
                students. The basic aim of CESA is to enrich students with different qualities to add dimensions to
                their personality so that every student emerges as multi-functional engineer who is globally
                recognized.',
                'Under CESA there different activities organized by the students for the students. The activities like
                different technical and non technical seminars, different competitions, different workshops and last
                but not the least different function for refreshment of the students are also organized by the CESA.',
                'Civil Engineering Student Association (CESA) is formed in 2013. CESA consists of a committee which is
                headed by President and vice president along with Member from every class. The president is from BE
                and vice president are strictly taken from TE only.',
                'Members are selected by taking interviews of the interested candidates by the expert panel of staff
                Member appointed by The Head of Department. </p>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-id-card mr-1"></i>
                <span>Committee</span>
              </template>
              <div class="shadow-md">
                <h4 class="text-xl font-semibold w-full bg-pink-700 p-2 text-white text-left">
                  The constitution of CESA club is as:</h4>
                <div class="w-full bg-white border-2 border-gray-50 px-2">
                  <ul class="list-reset text-black mb-8 p-4 text-gray-600 font-medium">
                    <li class="flex items-center mb-3"
                        v-for="(constitution,index) in constitutions" :key="index">
                      <div class="rounded-full border-2 bg-gray-600  p-1 mr-2 shadow-md">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                             fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd"/>
                        </svg>
                      </div>
                      <p class="text-justify">{{ constitution }}</p>
                    </li>
                  </ul>
                </div>
              </div>
              <p class="mt-3 ">Secretary are divided under four head namely Cultural Program, Events, Sports boys and
                Girls. Student's Committee is reformed every year.</p>
              <div class="my-2">
                <p class="text-gray-600 font-semibold">The working of the club would be governed by staff committee
                  known as
                  ‘governing body’ that constitutes-</p>
                <ul class="ml-3">
                  <li class="mt-3"><i class="pi pi-chevron-right"></i><span class="font-semibold">Patrons</span>-
                    Secretary Jagdamba Education Society and Principal
                  </li>
                  <li class="mt-3"><i class="pi pi-chevron-right"></i><span class="font-semibold">Chairman</span>-
                    Head of the Department
                  </li>
                  <li class="mt-3"><i class="pi pi-chevron-right"></i><span
                      class="font-semibold">CESA Coordinator</span>- Senior Teacher of Department
                  </li>
                </ul>
              </div>
              <p>Treasurer and Club coordinator are appointed by the governing body to facilitate smooth functioning
                of the club. Tenure of club coordinator would be of two years.</p>
              <div class="mt-3">
                <p class="text-xl font-bold bg-pink-600 text-white p-2">The CESA Committee for Academic year
                  2021-22</p>
                <TableCommittee class="text-justify"
                                :members="members"
                                :dir="dirName"/>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-bars mr-1"></i>
                <span>Activities</span>
              </template>
              <activity-component v-for="(activity,index) in civilactivities"
                                  :key="index"
                                  :activity="activity"/>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-align-justify mr-1"></i>
                <span>Activity Plan</span>
              </template>
              <ActivityPlans :activities="activities"/>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import TableCommittee from "@/components/TableCommittee";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ActivityPlans from "@/components/ActivityPlans";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Students_Club",
  components: {
    ActivityComponent,
    ActivityPlans,
    TableCommittee,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      constitutions: [
        'President 01 (preferably from B.E.)',
        'Vice President 01 (preferably from T.E.)',
        'Secretary (preferably from B.E.)',
        'Treasurer 01 (preferably from S.E.)',
        'Executive Member 6 (From any Class)',
        'All students are member of Association'],
      dirName: 'civil',
      members: [
        {
          sr: '1',
          name: 'TEKALE TUSHAR BALASAHEB',
          designation: 'President',
          photo: 'takale_tushar'
        },
        {
          sr: '2',
          name: 'SARODE PUJA SUNIL',
          designation: 'Vice President',
          photo: 'sarode_pooja'
        },
        {
          sr: '3',
          name: 'MOKATE PRATHMESH RAJENDRA',
          designation: 'Secretary',
          photo: 'mokate_prathmesh'
        },
        {
          sr: '4',
          name: 'WAKTE GOKUL JAYWANT',
          designation: 'Member',
          photo: 'wakte_gokul'
        },
        {
          sr: '5',
          name: 'GAIKWAD VAIBHAV KAILAS',
          designation: 'Member',
          photo: 'gaikwad_vaibhav'
        },
        {
          sr: '6',
          name: 'MADHVAI TEJAS SANJAY',
          designation: 'Member',
          photo: 'madhvai_tejas'
        },
        {
          sr: '7',
          name: 'JAGTAP PRAJAKTA ASHOK',
          designation: 'Member',
          photo: 'jagtap_prajkta'
        },
        {
          sr: '8',
          name: 'TALOLE AJINKYA SHIVAJI',
          designation: 'Member',
          photo: 'talole_ajinkya'
        },
        {
          sr: '9',
          name: 'DANGE AMIT UTTAM',
          designation: 'Member',
          photo: 'dange_amit'
        },
        {
          sr: '10',
          name: 'DANEJ PANKAJ RAVINDRA',
          designation: 'Treasurer',
          photo: 'danej_pankaj'
        }
      ],
      activities: [
        {
          month: '1<sup>st</sup> Month'
        },
        {
          sr: '1',
          activity: 'Formation of  Committee',
          tentative: 'First week'
        },
        {
          sr: '2',
          activity: 'Celebration of Teacher’s Day',
          tentative: 'First week'
        },
        {
          sr: '3',
          activity: 'Celebration of Engineer’s Day',
          tentative: 'Third Week'
        },
        {
          month: '2nd Month'
        },
        {
          sr: '4',
          activity: 'Celebration of Gandhi Jayanti',
          tentative: 'First week'
        },
        {
          sr: '5',
          activity: 'Expert talk on New Trends in Civil Engineering',
          tentative: 'Second Week'
        },
        {
          sr: '6',
          activity: 'Student Development Program for TE (Aptitude Test)',
          tentative: 'Second Week'
        },
        {
          sr: '7',
          activity: 'Student Development Program for TE (Aptitude Test)',
          tentative: 'Third Week'
        },
        {
          sr: '8',
          activity: 'Expert talk on Sustainability in Civil Engineering',
          tentative: 'Third Week'
        },
        {
          sr: '9',
          activity: 'Expert Talk ',
          tentative: 'Fourth Week'
        },
        {
          sr: '10',
          activity: 'Demo on AutoCad Software',
          tentative: 'Fourth Week'
        },
        {
          month: '3rd Month'
        },
        {
          sr: '11',
          activity: 'Expert talk ',
          tentative: 'First week'
        },
        {
          sr: '12',
          activity: 'Expert talk ',
          tentative: 'Second Week'
        },
        {
          sr: '13',
          activity: 'Demo of Primavera Software',
          tentative: 'Third Week'
        },
        {
          sr: '14',
          activity: 'Demo of MSP Software',
          tentative: 'Third Week'
        },
        {
          sr: '15',
          activity: 'Guest Lecture on Albedo Foundation',
          tentative: 'Fourth Week'
        },
        {
          sr: '16',
          activity: 'Expert talk ',
          tentative: 'Fourth Week'
        },
        {
          month: '4th Month'
        },
        {
          sr: '17',
          activity: 'Student Development Program for BE (Aptitude Test)',
          tentative: 'First week'
        },
        {
          sr: '18',
          activity: 'Expert Talk on SAP in construction industry',
          tentative: 'Second Week'
        },
        {
          sr: '19',
          activity: 'Student Development program for BE (GD and PI)',
          tentative: 'Second Week'
        },
        {
          sr: '20',
          activity: 'Expert Talk on Competitive Exam',
          tentative: 'Third Week'
        },
        {
          sr: '21',
          activity: 'End of Semester',
          tentative: 'Fourth Week'
        },
      ],
      civilactivities: [
        {
          name: "A guest lecture was conducted on Construction of Nuclear Power plant",
          date: "",
          details: "A guest lecture was conducted on Construction of Nuclear Power plant by Dr Chandrashekra .He taught the construction phases of a new nuclear power plant and vital safe operation of the facility through its design life.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/nuclear_power.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/nuclear_power.jpg",
              "alt": "Construction of Nuclear Power plant",
              "title": "Guest Lecture"
            },

          ]
        },
        {
          name: "Expert lecture on Dams and Hydraulic Structure",
          date: "05 Jan 2017",
          details: "Expert lecture on Dams and Hydraulic Structure  was delivered by Dr.C.L.Jejurkar on 05/01/2017. He explained major hydraulic aspects of dam engineering considering recent developments in research and construction, namely overflow, conveyance and dissipations structures of spillways, river diversion facilities during construction, bottom and low-level outlets as well as intake structures. Furthermore, the he covered reservoir sedimentation, impulse waves and dam break waves, which are relevant topics in view of sustainable and safe operation of reservoirs.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/hydralic_lecture.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/hydralic_lecture.jpg",
              "alt": "Expert lecture on Dams and Hydraulic Structure",
              "title": "Guest Lecture"
            },

          ]
        },
        {
          name: "A guest lecture on How to crack MPSC Engineering Service Exam",
          date: "08 Sep 2016",
          details: "A guest lecture on “How to crack MPSC Engineering Service Exam” was held on 08 September 2016. The guest lecture was organized by CESA to provide the students with brief introduction about the syllabus and exam pattern of MPSC Engineering Service exam. The lecture was delivered by Er.Uddhav Murkute who is working as Executive Engineer in Water Resource department Government of Maharashtra.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/mpsc_guest_lecture.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/mpsc_guest_lecture.jpg",
              "alt": "A guest lecture on “How to crack MPSC Engineering Service Exam",
              "title": "Guest Lecture"
            },

          ]
        },]
    }
  }
}
</script>
<style lang="scss" scoped/>
